module.exports = __webpack_public_path__ + "static/media/FuturaBT-Medium.ee64fb9d.ttf";